module.exports = __webpack_public_path__ + "static/media/Icons_Facebook_white.6ade3fc6.svg";